/**
 * Sidebar 导航配置
 */

import {
  Star,
  ShipWheel,
  Trash2,
  PanelTop,
  Image,
  FileType,
  BookOpenText,
  SquarePlay,
  ExternalLink,
  Workflow,
  CopyMinus,
  Inbox,
  Puzzle,
} from "lucide-react";

import { ROUTE_PATHS } from "@/shared/constants/route-paths";

import type { MainNavItem, SecondaryNavItem } from "./types";

/**
 * 主导航配置
 */
export const MAIN_NAV_ITEMS: MainNavItem[] = [
  {
    title: "未分类",
    url: ROUTE_PATHS.MINE,
    icon: Inbox,
    badge: 33,
  },
  {
    title: "全部收藏",
    url: ROUTE_PATHS.MINE_ALL,
    icon: Star,
    items: [
      {
        title: "网页",
        url: `${ROUTE_PATHS.MINE_ALL}?format=website`,
        icon: PanelTop,
      },
      {
        title: "图片",
        url: `${ROUTE_PATHS.MINE_ALL}?format=image`,
        icon: Image,
      },
      {
        title: "笔记",
        url: `${ROUTE_PATHS.MINE_ALL}?format=text`,
        icon: FileType,
      },
      {
        title: "PDF",
        url: `${ROUTE_PATHS.MINE_ALL}?format=pdf`,
        icon: BookOpenText,
      },
      {
        title: "视频",
        url: `${ROUTE_PATHS.MINE_ALL}?format=video`,
        icon: SquarePlay,
      },
    ],
  },
  {
    title: "发现",
    url: "#",
    icon: ShipWheel,
    subIcon: ExternalLink,
  },
];

/**
 * 次要导航配置
 */
export const SECONDARY_NAV_ITEMS: SecondaryNavItem[] = [
  {
    title: "回收站",
    url: ROUTE_PATHS.MINE_TRASH,
    icon: Trash2,
  },
  {
    title: "流程",
    url: ROUTE_PATHS.MINE_WORKFLOW,
    icon: Workflow,
  },
  {
    title: "查找重复收藏",
    url: ROUTE_PATHS.MINE_DUPLICATES,
    icon: CopyMinus,
  },
  {
    title: "插件",
    url: ROUTE_PATHS.MINE_PLUGINS,
    icon: Puzzle,
  },
];
